import { render, staticRenderFns } from "./FormUploadView.vue?vue&type=template&id=fb52cfe0&scoped=true&"
import script from "./FormUploadView.vue?vue&type=script&lang=js&"
export * from "./FormUploadView.vue?vue&type=script&lang=js&"
import style0 from "./FormUploadView.vue?vue&type=style&index=0&id=fb52cfe0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb52cfe0",
  null
  
)

export default component.exports